/**
 * Lataa kaikki PNG-ikonit Vite-manifestiin, jotta frontend_asset_path löytää ne.
 * Tämä käyttää eager-importtia, jolloin importit tapahtuvat buildissa.
 */
/**
 * Lataa kaikki PNG-ikonit buildiin, jotta ne päätyvät manifestiin.
 * Webpack-versio (ei käytä Viten import.meta.glob:ia).
 */
function importAll(r) {
  r.keys().forEach(r);
}

// Lataa kaikki tiedostot hakemistosta ../images/icons/*.png
importAll(require.context('../images/icons', false, /\.png$/));

// Jos tarvitset koodissa viitteen, exporttaa map (valinnainen):
export const _icons = (() => {
  const r = require.context('../images/icons', false, /\.png$/);
  return Object.fromEntries(
    r.keys().map(k => [ `icons/${k.replace('./','')}`, r(k) ])
  );
})();

